/*
 * @Author: your name
 * @Date: 2022-04-25 11:39:49
 * @LastEditTime: 2022-04-25 14:52:42
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \brand-source-web\src\utils\js\base.js
 */
'use strict';
var base;
base = {
    //判断字符串是否符合手机号码格式 错误提示:号码格式错误,固话需加区号和符号‘-’
    checkPhone: function (tel) {
        tel = tel.replace(/&nbsp;/ig, "");
        tel = tel.trim();
        var r = /^((0\d{2,3}-\d{7,8})|(1+\d{10}))$/;

        if (r.test(tel)) {
            return true;
        }

        return false;
    },
    isEmptyObject: function (obj) {
        for (var k in obj) {

            return false;
        }
        return true;
    },
    //判断统一社会信用代码
    checkCreditcode: function (code) {
        var code = $.trim(code).replace(/\n/g, "");
        if(!(/^(\w{15}|\w{18})$/g).test(code)){
            layer.msg('请填写正确的统一社会信用代码！');
            return false;
        }
        return true;
    },

    isJsonObj: function(str) {
        try {
            if (typeof JSON.parse(str) == "object") {
                return true;
            }
        } catch(e) {
        }
        return false;
    },
    // 存储localStorage，设置过期时间
    localStorageSet: function(lname, ldata, exDay){
        const obj = {
            ldata,
            expire: exDay ? new Date().getTime() + (1000 * 60 * 60 * 24 * exDay) : null
        };
        localStorage.setItem(lname, JSON.stringify(obj));
    },
    // 获取localStorage，过期则返回null
    localStorageGet: function(lname) {
        const storage = localStorage.getItem(lname);
        const time = new Date().getTime();
        let result = null;
        if (storage && this.isJsonObj(storage)) {
            const obj = JSON.parse(storage);
            if (!obj.expire || time < obj.expire) {
                result = obj.ldata;
            } else {
                localStorage.removeItem(lname);
            }
        }
        return result;
    },
    //操作cookie
    setCookie: function (cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = exdays ? "expires=" + d.toUTCString()+';' : '';
        var cookie_domain = "domain=" + document.domain;
        document.cookie = cname + "=" + cvalue + "; " + expires + "path=/;"+cookie_domain;
    },
    getCookie: function (key) {
        var getCookie = document.cookie.replace(/[ ]/g, "");
        var arrCookie = getCookie.split(";")
        var tips;
        for (var i = 0; i < arrCookie.length; i++) {
            var arr = arrCookie[i].split("=");
            if (key == arr[0]) {
                tips = arr[1];
                break;
            }
        }
        return tips;
    },
    clearCookie: function (name) {
        this.setCookie(name, "", -1);
    },
    isRepeat: function(arr){
        arr = arr.sort();
        for(var i=0;i<arr.length;i++) {
            if (arr[i] == arr[i+1]) {
                return false;
            }
        }
        return true;
    },
    // input值双向绑定
    listenInputText: function (input, callback) {
        Object.defineProperties(input, '_value', {
            configurable: true,
            set: function (value) {
                this.value = value;
                callback();
            },
            get: function () {
                return this.value;
            }
        })
    },
    replaceEmpty(name,separator){
        if(!name || name=='' || name==null || name==undefined){
            return separator
        } else {
            return name
        }
    },
    /**
     * 根据身份证号得到姓别和精确计算年龄
     */
    analyzeIDCard: function (IDCard){
        //获取用户身份证号码
        var userCard = IDCard;
        //如果身份证号码为undefind则返回空
        if(!userCard){
            return false;
        }
        //获取出生年月日
        var yearBirth = userCard.substring(6,10);
        var monthBirth = userCard.substring(10,12);
        var dayBirth = userCard.substring(12,14);
        //获取当前年月日并计算年龄
        var myDate = new Date();
        var monthNow = myDate.getMonth() + 1;
        var dayNow = myDate.getDate();
        var age = myDate.getFullYear() - yearBirth;
        if(monthNow < monthBirth || (monthNow == monthBirth && dayNow < dayBirth)){
            age--;
        }
        if (age >= 18) { return true; }
        return false;
    },

};

export default base;
